// Pure, dependency-free URL-derived display names, shared by the docs and repo
// panes so a link is meaningful by its URL alone when it has no explicit title.

// `org/repo` slug from the path (trailing `.git` trimmed); a single segment when
// that's all there is; the raw URL when it can't be parsed.
export function repoDisplayName(url) {
  try {
    const parts = new URL(url).pathname.split('/').filter(Boolean);
    if (parts.length >= 2) return `${parts[0]}/${parts[1]}`.replace(/\.git$/, '');
    if (parts.length === 1) return parts[0].replace(/\.git$/, '');
    return url;
  } catch {
    return url;
  }
}

// Last non-empty, URL-decoded path segment (e.g. `.../blob/main/README.md` ->
// `README.md`); the hostname when there is no path; the raw URL when unparseable.
export function docDisplayName(url) {
  try {
    const parsed = new URL(url);
    const parts = parsed.pathname.split('/').filter(Boolean);
    if (parts.length === 0) return parsed.hostname;
    return decodeURIComponent(parts[parts.length - 1]);
  } catch {
    return url;
  }
}
